import React, { useContext, useState } from 'react'
import AppBar from '@mui/material/AppBar'
import Grid from '@mui/material/Grid'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import {
  Box,
  Button,
  Container,
  Divider,
  IconButton,
  Stack,
  Toolbar,
  Tooltip,
  Typography,
} from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import { ClientPortalContext } from '../ClientPortal'
import { UserContext } from '../../../../App'
import API from '../../../../services/API'
import { useNavigate, useLocation } from 'react-router-dom'

const menuItems = [
  { label: 'Dashboard', path: '/' },
  { label: 'Events', path: '/events' },
  { label: 'H&S Incidents', path: '/health-safety-incidents' },
  // TODO: { label: 'Invoices', path: '/invoices' },
  // TODO: { label: 'Request Cover', path: '/request-cover' },
]

const ClientPortalMenu = () => {
  const [anchorElNav, setAnchorElNav] = useState(null)
  const [anchorElUser, setAnchorElUser] = useState(null)
  const { user, setUser } = useContext(UserContext)
  const navigate = useNavigate()
  const location = useLocation()

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget)
  }
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget)
  }

  const handleCloseNavMenu = () => {
    setAnchorElNav(null)
  }

  const handleCloseUserMenu = () => {
    setAnchorElUser(null)
  }

  return (
    <Grid item xs={12} order={3}>
      <AppBar position="relative" sx={{ borderRadius: 2 }}>
        <Toolbar disableGutters>
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              anchorEl={anchorElNav}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{ display: { xs: 'block', md: 'none' } }}
            >
              {menuItems.map((m, index) => (
                <MenuItem key={index} onClick={() => navigate(m.path)}>
                  <Typography sx={{ textAlign: 'center' }}>
                    {m.label}
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: 'none', md: 'flex' },
              paddingX: 4,
            }}
          >
            <Stack direction="row" gap={2}>
              {menuItems.map((m, index) => (
                <Button
                  key={index}
                  onClick={() => navigate(m.path)}
                  variant={location.pathname === m.path ? 'contained' : 'text'}
                  //   size="small"
                  color="anWhite"
                  sx={{ my: 0, display: 'block' }}
                >
                  {m.label}
                </Button>
              ))}
            </Stack>
          </Box>
          <Box
            sx={{ flexGlow: 0, paddingX: 4, cursor: 'pointer' }}
            onClick={anchorElUser ? handleCloseUserMenu : handleOpenUserMenu}
          >
            <Typography color="white">
              {user.firstName} {user.lastName}
            </Typography>
            <Menu
              sx={{ mt: '45px' }}
              anchorEl={anchorElUser}
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={!!anchorElUser}
              onClose={handleCloseUserMenu}
            >
              <MenuItem
                onClick={() => {
                  API.delete('/logout')
                    .then((res) => {
                      setUser({})
                      window.location.reload()
                    })
                    .catch((e) => console.log(e))
                }}
              >
                Logout
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>
    </Grid>
  )
}

export default ClientPortalMenu
